// 成品
<template>
  <div>
    <div class="bill-area" ref="bill" v-if="isDom">
      <p class="tit">
        {{ labelInfo.productModel }} {{ labelInfo.specification }}
      </p>
      <!-- <div class="info_box">
        <p class="item">标签编号：{{ labelInfo.finishedProductNo }}</p>
        <p class="item">销售订单号：{{ labelInfo.orderNo }}</p>
        <p class="item">生产订单号：{{ labelInfo.finishedProductBatchNo }}</p>
        <p class="item">仓库编号：{{ labelInfo.wareHouseNo }}</p>
        <p class="item">批次号：{{ labelInfo.finishedProductBatchNo }}</p>
        <p class="item">长度：{{ labelInfo.length }}</p>
      </div> -->
      <div class="code_box" id="qrCode" ref="qrCodeDiv"></div>
    </div>
    <div class="canvas-bill" v-else>
      <img :src="canvasImageUrl" alt="" />
    </div>
    <!-- <div class="save_btn" @click="htmlToCanvas">保存二维码图片</div> -->
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
export default {
  props: {
    labelInfo: {
      type: Object,
      default: {},
    },
  },
  name: "Home",
  data() {
    return {
      isDom: true,
      canvasImageUrl: "",
      ip: window.localStorage.getItem("ip") || "",
    };
  },
  created() {
    this.$nextTick(() => {
      new QRCode(this.$refs.qrCodeDiv, {
        text: this.labelInfo.finishedProductNo,
        width: 140,
        height: 140,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    });
  },
  mounted() {
    console.log("labelInfo", this.labelInfo);
    // // 二维码地址
    // this.qrcodeUrl = data.data.inviteCodeAddress;
    // // 调用html转化canvas函数
    // this.htmlToCanvas();
    setTimeout(() => {
      this.htmlToCanvas();
    }, 1000);
  },
  methods: {
    htmlToCanvas() {
      html2canvas(this.$refs.bill, {
        background: "#ffffff", // 一定要添加背景颜色，否则出来的图片，背景全部都是透明的
        dpi: 1080,
      }).then((canvas) => {
        let imageUrl = canvas.toDataURL("image/png"); // 将canvas转成base64图片格式
        this.canvasImageUrl = imageUrl;
        this.isDom = false;
        this.onPrinter();
        // androidCallbackAction.print(imageUrl)
      });
    },

    onPrinter() {
      this.$axios
        .printerImgPrint({
          ip: this.ip,
          fileBase64: this.canvasImageUrl,
        })
        .then((res) => {
          if (res.status == 200) {
            if (res.data.status == 200) {
              setTimeout(() => {
                this.$parent.onIn();
              }, 3000);
              // this.$message.success("打印成功");
            } else {
              this.$parent.onIn(2);
              this.$message.error("打印失败");
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.bill-area .info_box .item {
  line-height: 40px;
}
</style>